import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setActiveComponent } from '../../Redux/Slices/activeComponentSlice';
import { tokenStorage } from '../../api/index';

const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const token = tokenStorage.getToken();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!token) {
            const redirectPath = location.pathname + location.search;
            sessionStorage.setItem('authRedirect', redirectPath);
            dispatch(setActiveComponent("signIn"));
            
            const searchParams = new URLSearchParams(location.search);
            searchParams.set('redirect', redirectPath);
            navigate(`/signin?${searchParams.toString()}`, { replace: true });
        }
    }, [token, navigate, location, dispatch]);

    if (!token) {
        return null;
    }
    return children;
};

export default ProtectedRoute; 